import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./slice/store";
import { BrowserRouter } from "react-router-dom";
// import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <GoogleOAuthProvider clientId="38130082128-852u2cp3sfuhvkn40p8c5f3etsrtv3vd.apps.googleusercontent.com">
  <Provider store={store}>
    <BrowserRouter basename="/signature/">
      <App />
    </BrowserRouter>
  </Provider>
  // </GoogleOAuthProvider>
);
